const Validator = {
    start: (...elements) => {
        let counter = 0
        elements.forEach(element => {
            if (element == null) {
                counter++
            }
            else {
                if (element instanceof Array) {
                    if (element.length == 0) {
                        counter++
                    }
                }
                else if (element instanceof String) {
                    if (element == undefined || element == null || element == "") {
                        counter++
                    }
                }
                else {
                    if (element == undefined || element == null) {
                        counter++
                    }
                }
            }
        })
        return counter == 0
    },
}

export default Validator